import DropdownMenuItem from "ds/components/DropdownMenu/Item";

import { showDeleteConfirmation } from "./DeleteConfirmation";

type ContextsDeleteDropdownItemProps = {
  hasAttachedEntities: boolean;
  id: string;
  name: string;
  onSuccess?: () => void;
  isDisabled?: boolean;
  tooltip?: string;
};

const ContextsDeleteDropdownItem = ({
  hasAttachedEntities,
  id,
  name,
  onSuccess,
  isDisabled,
  tooltip,
}: ContextsDeleteDropdownItemProps) => {
  const handleDelete = () => {
    showDeleteConfirmation({
      id,
      hasAttachedEntities,
      name,
    }).then((finished) => {
      if (finished && onSuccess) {
        onSuccess();
      }
    });
  };

  return (
    <DropdownMenuItem
      onAction={handleDelete}
      danger
      isDisabled={isDisabled}
      tooltip={tooltip}
      tooltipPlacement="left"
    >
      Delete
    </DropdownMenuItem>
  );
};

export default ContextsDeleteDropdownItem;
